var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEye = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10.428,
    viewBox: "0 0 20 10.428",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e80000",
    d: "M10.656 8c-5.433 0-9.613 4.786-9.613 4.786l-.387.428.387.428s3.811 4.346 8.88 4.745a6.619 6.619 0 0 0 1.466 0c5.069-.4 8.88-4.745 8.88-4.745l.387-.428-.387-.428S16.089 8 10.656 8zm0 1.3a9.441 9.441 0 0 1 3.91.916 4.491 4.491 0 0 1 .652 2.342 4.559 4.559 0 0 1-4.053 4.542h-.041c-.155.008-.311.02-.468.02-.173 0-.341-.01-.509-.02a4.574 4.574 0 0 1-3.422-6.86h-.02a9.463 9.463 0 0 1 3.951-.94zm0 1.3a1.955 1.955 0 1 0 1.955 1.955 1.956 1.956 0 0 0-1.955-1.948zm-5.7.611a5.795 5.795 0 0 0 .733 4.46 15.117 15.117 0 0 1-3.159-2.457 15.6 15.6 0 0 1 2.424-1.996zm11.405 0a15.6 15.6 0 0 1 2.424 2 15.117 15.117 0 0 1-3.157 2.464 5.795 5.795 0 0 0 .733-4.46z",
    transform: "translate(-.656 -8)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye.bd1bb7b7.svg";
export { ForwardRef as ReactComponent };